module.exports = __webpack_public_path__ + "static/media/Tooth_icon_f77935.96adc401.svg";